<template>
  <section class="iv-activity" :class="{'iv-activity-my': currentType === 'myRegistration'}">
    <header class="iv-activity-header">
      <ul class="iv-main-width">
        <li 
          v-for="(item, index) in tabs" 
          :key="item.value" 
          class="iv-fc-65 iv-fs-16 iv-pointer" 
          :class="{'iv-m-l-40': index !== 0, 'iv-fc-85': item.value === currentType, 'iv-fw-b': item.value === currentType}"
          @click="switchTabs(item)"
        >
          <template v-if="item.value !== 'search'">{{item.title}}</template>
          <template v-else>
            <Input v-model="searchActivity" placeholder="可搜索活动名称和活动发布组织名称" style="width: 480px;">
              <Select v-model="searchOrganizationType" slot="prepend" style="width: 88px" @on-change="searchActivityHandle">
                <Option value="self">本组织</Option>
                <Option value="other">全部组织</Option>
              </Select>
              <Button class="iv-activity-btn" slot="append" type="search" :disabled="disabled" @click="searchActivityHandle">搜索</Button>
            </Input>
          </template>
        </li>
      </ul>
    </header>
    <div class="iv-activity-wrap">
      <!-- 图文列表 -->
      <article v-show="activityList.length > 0 && currentType !== 'myRegistration'" class="iv-activity-content iv-main-width iv-p-b-24">
        <div class="iv-activity-content-list">
          <dl
            v-for="(item, index) in activityList"
            :key="item.eventInfoId"
            class="iv-activity-content-item iv-m-t-24 iv-pointer" 
            :class="{'iv-m-r-24': (index + 1) % 3 !== 0}"
            @click="toActivityPage(item)"
          >
            <dt class="iv-activity-content-item-img">
              <img :src="getCoverImage(item.eventCoverFileId)" alt="">
              <span v-if="item.isPinOnTop == '1'" class="iv-activity-content-item-img-zhiding">置顶</span>
              <p
                class="iv-activity-img-tag iv-text-center"
                :class="{'iv-home-tag-orange': Date.now() >= item.applicationDeadline && item.infoState == 'SBZT02', 'iv-home-tag-transparent': item.infoState == 'SBZT04', 'iv-home-tag-pink': item.infoState == 'SBZT02' && Date.now() < item.applicationDeadline}"
              >
                {{calculateDeadline(item)}}
              </p>
            </dt>
            <dd class="iv-activity-content-item-text">
              <h3 class="iv-fc-85 iv-fs-16">{{item.applicationName}}</h3>
              <p class="iv-fs-16 iv-fc-45 iv-m-t-8">{{item.publishOrgName}}</p>
            </dd>
          </dl>
        </div>
        <Page 
          v-if="showPage" 
          :total="total" 
          :current="currentPage" 
          :pageSize="pageSize" 
          :pageSizeOpts="[6, 9, 15, 30]"
          class="iv-activity-content-page iv-m-t-40" 
          @on-change="changePage" 
          @on-page-size-change="changePageSize">
        </Page>
      </article>
      <!-- 我的报名 -->
      <MyRegistration 
        v-if="activityList.length && currentType === 'myRegistration'"
        :list="activityList" 
      ></MyRegistration>
      <NoData v-show="!activityList.length"></NoData>
      <Spin v-if="spinShow" fix></Spin>
    </div>
  </section>
</template>

<script>
import Page from '@/components/page'
import NoData from '@/components/no-data'
import { getToken } from '@/utils'
import MyRegistration from './my-registration/index.vue'
  
export default {
  data () {
    return {
      searchActivity: '',
      searchOrganizationType: 'self',
      currentType: '',
      activityList: [],
      total: 0,
      currentPage: 1,
      pageSize: 9,
      showPage: true,
      dictMap: {},
      spinShow: false,
      disabled: false
    }
  },
  async created () {
    this.map = {
      title: 'eventInfoName',
      orgName: 'publishOrgName',
      publishDate: 'publicTime',
      endDate: 'eventEndTime'
    }
    this.idMap = JSON.parse(sessionStorage.getItem('idMap') || '{}')
    this.initTabs()
    this.getCodeTable('BOE25')
    this.getCodeTable('BOE45')
    await this.getCodeTable('BOE44')
    this.getActivityList()
  },
  provide () {
    return {
      getMyRegistrationList: this.getMyRegistrationList
    }
  },
  methods: {
    getCoverImage (photo) {
      if (photo) {
        return `api-uum/file/downloadFile?fileId=${photo}&access_token=${getToken()}`
      } else {
        return require('@/assets/images/course/cover-image-1.png')
      }
    },
    //切换tab
    switchTabs (item) {
      if (item.value === 'search') return
      this.searchActivity = ''
      this.currentType = item.value
      //在我的报名时禁止搜索
      if (item.value == 'myRegistration') {
        this.disabled = true
        this.getMyRegistrationList()
      } else {
        this.getActivityList()
      }
    },
    //搜索
    searchActivityHandle () {
      this.getActivityList()
    },
    //获取活动列表
    getActivityList () {
      this.spinShow = true
      this.$ajax({
        url: 'api-general/module/v2event/listApplicationInfo',
        method: 'get',
        data: {
          bizLineCode: this.currentType,
          bizTypeCode: 'YWLX03',
          infoState: 'SBZT02',
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          applicationNameAndPublishOrgName: this.searchActivity,
          // orgId: this.searchOrganizationType == 'self' ? sessionStorage.getItem(this.idMap[this.currentType]) : ''
          orgId: this.searchOrganizationType == 'self' ? true : false
        }
      }).then(({data}) => {
        this.activityList = data.data || []
        this.total = data.count
        this.spinShow = false
      })
    },
    //获取我的报名列表
    getMyRegistrationList (pageSize, currentPage) {
      this.spinShow = true
      this.$ajax({
        url: 'api-general/module/v2event/listApplicationObject',
        method: 'get',
        data: {
          pageSize: pageSize,
          currentPage: currentPage,
        }
      }).then(({data}) => {
        this.activityList = data.data || []
        this.total = data.count
        this.spinShow = false
      })
    },
    //计算截止时间
    calculateDeadline (item) {
      if (!item.applicationDeadline) return
      if (item.infoState == 'SBZT04') {
        return '已结束'
      } else {
        const info = this.createTimer(item)
        return info
      }
    },
    createTimer (item) {
      const currentDate = Date.now()
      const distance = item.applicationDeadline - currentDate
      let info = ''
      if (distance < 0 && item.infoState == 'SBZT02') {
        info = '报名截止 活动进行中'
      }
      if (distance >= 0 && item.infoState == 'SBZT02') {
        //天
        const day = Math.floor(distance / (1000 * 60 * 60 * 24))
        //时
        const hour = Math.floor((distance / (1000 * 60 * 60)) % 24)
        //分
        const minutes = Math.floor((distance / (1000 * 60)) % 60)
        info = `还剩${day ? day + '天' : ''}${hour ? hour + '时' : ''}${minutes ? minutes + '分' : ''}`
      }
      return info
    },
    //跳转活动详情页
    toActivityPage (item) {
      this.$router.push({
        name: 'activityDetail',
        query: {
          applicationInfoId: item.applicationInfoId,
          isSignUp: item.isSignUp === true ? 'yes' : 'no',
          currentType: this.currentType,
          bizLineCode: this.currentType
        }
      })
    },
    //分页
    changePage (num) {
      this.currentPage = num
      this.getActivityList()
    },
    //条数
    changePageSize (num) {
      this.pageSize = num
      this.getActivityList()
    },
    //初始化tabs
    initTabs () {
      // const tabs = JSON.parse(sessionStorage.getItem('identityOrgs') || '[]')
      // this.tabs = tabs.map(item => {
      //   return {
      //     title: item.systemName,
      //     value: item.identityType
      //   }
      // })
      this.tabs = [
        {
          title: '党建引领',
          value: 'YWX01'
        },
        {
          title: '工会服务',
          value: 'YWX03'
        },
        {
          title: '青团建设',
          value: 'YWX04'
        },
        {
          title: '企业文化',
          value: 'YWX05'
        },
        {
          title: '数字CCO',
          value: 'YWX06'
        }
      ]
      this.tabs.push({
        title: '搜索',
        value: 'search'
      }, {
        title: '我的报名',
        value: 'myRegistration'
      })
      this.currentType = this.$route.query.currentType || this.tabs[0].value
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = {}
          data.data.length && data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    }
  },
  components: {
    Page,
    NoData,
    MyRegistration
  }
}
</script>

<style lang="scss" scoped>
@import 'variable/variable.scss';
.iv-activity {
  height: calc(100vh - 64px);
  background-color: #F5F7FA;
  overflow: hidden;
  .iv-activity-header {
    width: 100%;
    height: 64px;
    background-color: #fff;
    ul {
      display: flex;
      align-items: center;
      height: 100%;
    }
    /deep/ .ivu-input-wrapper {
      height: 40px;
      .ivu-input-group-prepend {
        background: #F5F7FA;
        border: none;
        .ivu-select-selected-value {
          font-size: 14px;
          color: $iv-fc-65;
        }
        .ivu-select-selection {
          border: none !important;
          box-shadow: none !important;
        }
      }
      .iv-activity-btn {
        height: 40px;
        color: #fff !important;
        border: 1px solid $iv-main-color !important;
        background-color: $iv-main-color !important;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      .ivu-input {
        height: 100% !important;
        background: #F5F7FA;
        border: none;
        box-shadow: none !important;
        font-size: 14px;
        color: $iv-fc-65;
      }
    }
  }
  .iv-activity-wrap {
    height: calc(100vh - 128px);
    overflow-y: auto;
  }
  .iv-activity-content {
    .iv-activity-content-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .iv-activity-content-item {
        width: 384px;
        height: 312px;
        background: #FFFFFF;
        border-radius: 8px;
        .iv-activity-content-item-img {
          width: 100%;
          height: 216px;
          position: relative;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          img {
            width: 100%;
            height: 100%;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          }
          .iv-activity-content-item-img-zhiding {
            display: inline-block;
            position: absolute;
            top: 0;
            left: 0;
            width: 48px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            color: #fff;
            background: #FF8F82;
            border-top-left-radius: 8px;
            border-bottom-right-radius: 8px;
          }
          .iv-activity-img-tag {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 190px;
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            font-weight: 500;
            color: #fff;
          }
          .iv-home-tag-pink {
            background: url('~@/assets/images/index/pink.png') no-repeat;
            background-size: 100% 100%;
          }
          .iv-home-tag-orange {
            background: url('~@/assets/images/index/orange.png') no-repeat;
            background-size: 100% 100%;
          }
          .iv-home-tag-transparent {
            background: url('~@/assets/images/index/transparent.png') no-repeat;
            background-size: 100% 100%;
          }
        }
        .iv-activity-content-item-text {
          padding: 20px;
          h3 {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
    .iv-activity-content-page {
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
    }
  }
}
.iv-activity-my {
  background-color: #fff;
  .iv-activity-header {
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.09);
  }
}
</style>